import { createContext, useContext, useState, useEffect } from "react";
import { getMe } from "../util/wordywhiz";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getMe()
      .then((data) => {
        setIsLoggedIn(data.isLoggedIn);
        if (data.isLoggedIn) setUser(data);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  function setLoggedIn(userData) {
    setIsLoggedIn(true);
    setUser(userData);
  }

  function setLoggedOut() {
    setIsLoggedIn(false);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, isLoading, setLoggedIn, setLoggedOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
